// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner[data-v-1981fc75]{width:3rem;height:3rem}", ""]);
// Exports
module.exports = exports;
